import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomersService } from '../../../services/customers.service';
import { ToastrService } from 'ngx-toastr';
import { SetupDataService } from '../../../services/setupdata.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { InvoiceService } from '../../../services/invoice.service';
import { CreateloadService } from '../../../services/createload.service';
import { ReceiptPaymentService } from '../../../services/receiptpayment.service';
import { Router } from '@angular/router';
import { DwollacustomerService } from '../../../services/dwollacustomer.service';
import { MatDialog } from '@angular/material/dialog';
import { DecimalPipe } from '@angular/common';
import { ReceiptPaymentForm } from '../../../model/receptPayment';
import { ReceiptPaymentDetails } from '../../../model/receptPaymentDetails';
import { DxDataGridComponent } from 'devextreme-angular';
import { DwollapaymentpopupComponent } from '../../e-banking/dwollapaymentpopup/dwollapaymentpopup.component';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-common-reciept',
  templateUrl: './common-reciept.component.html',
  styleUrls: ['./common-reciept.component.scss'],
  providers: [CustomersService, ToastrService, SetupDataService],

})
export class CommonRecieptComponent implements OnInit {


  constructor(
    private formBuilder: UntypedFormBuilder,
    private _customersservice: CustomersService,
    private __invoiceservice: InvoiceService,
    private _loadservice: CreateloadService,
    private _receiptpaymentservice: ReceiptPaymentService,
    private _toaster: ToastrService,
    private router: Router,
    private _setupDataSetvice: SetupDataService,
    private _dwollaCustomerService: DwollacustomerService,
    public dialog: MatDialog,
    private decimalPipe: DecimalPipe
  ) { }

  searchForm: UntypedFormGroup;
  receiptPayment = {} as ReceiptPaymentForm;
  receiptPaymentDetail = {} as ReceiptPaymentDetails;
  loadstatusDetails: any = [];
  totalPayment = 0;
  isDataLoading = false;
  paymentDate;
  selectedCustomer: any[] = [];
  loadingVisible = false;
  paymentMethods: any[] = [];
  bankList: any[] = [];
  readonly allowedPageSizes = [5, 10, "all"];
  displayMode = "full";

  showPageSizeSelector = true;

  showInfo = true;

  showNavButtons = true;
  isEdited = true;
  rAmount = 0;
  dwollaCustomerData: any[] = [];
  senderFundingSourceId = "";
  recieverFundingSourceName = "";
  receiverFundingSourceId = "";
  senderFundingSourceName = "";
  receiverDwollaCUstomerData;
  senderDwollaCUstomerData;
  remainingReceivedAmount: number = 0;
  isReceivedValid: boolean = true;
  isRoundupValid: boolean = true;
  isDiscountValid: boolean = true;
  isBankChargeValid: boolean = true;
  isPaymentValid: boolean = true;
  totalAmount: number = 0;
  isACH = false;
  isCash = false;
  postedInvoiceList = [];
  ngOnInit() {
    var date = new Date();
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();
    this.paymentDate =
      yyyy +
      "-" +
      (mm[1] ? mm : "0" + mm[0]) +
      "-" +
      (dd[1] ? dd : "0" + dd[0]);
    this.loadstatusDetails = this._loadservice.getLoadStatusList("invoice");
    this.searchFormBuild();
    // this.getCustomerdata();
    this.getInvoices();
    this.getPaymentMethod();
    this.getBankAccounts();
    this._dwollaCustomerService.getDwollaAllCustomerData().subscribe((data) => {
      this.dwollaCustomerData = data.result;
    });

  }
  private getPaymentMethod() {
    this._setupDataSetvice.getBCPaymentMethods().subscribe((data) => {
      this.paymentMethods = data.result;
    });
  }
  private getBankAccounts() {
    this._setupDataSetvice.getBCBanks().subscribe((data) => {
      this.bankList = data.result;
    });
  }

  searchFormBuild() {
    this.searchForm = this.formBuilder.group(
      {
        customer: ["All", Validators.required],
        customerId: ["", Validators.required],
        senderDwollaCustomerId: [""],
        isDwollaCustomer: [false],
        date: [this.paymentDate],
        paymentMethod: [""],
        bankAccount: [""],
        receivedAmount: [""],
        paymentReference: [""],
        bankCharge: [""],
        discount: [""],
        roundup: [""],
      },
      {}
    );
  }
  dataBuild() { }
  SearchedData: any;
  StatusList;
  getData(searchOptions) {
    console.log(searchOptions);
    this.__invoiceservice
      .getLoadsForInvoice(searchOptions)
      .subscribe((data) => {
        this.StatusList = this._loadservice.getLoadStatusList("");
        let invoiceSearchOption = {cancelled: false};
        if(searchOptions?.customerId){
          console.log(this.customerdata);
          let customerInfo = this.customerdata.find((customer) => customer?.customerId?._id == searchOptions?.customerId);
          console.log(customerInfo?.customerId?.ErpEntityNo);
          invoiceSearchOption["customerId"] = customerInfo?.customerId?.ErpEntityNo;
        }
        this.__invoiceservice.getBCpostedInvoiceList(invoiceSearchOption).subscribe((data1) => {
          console.log(data1);
          this.postedInvoiceList = data1.result;
          this.getLoadGrid(data.result);
        })
      });
  }
  InvoiceLineItems = [];
  Invoices = [];
  customerdata = [];
  filteredCustomers;
  customerNameIdMap = {};
  getInvoices() {
    this.customerdata = [];
    this.__invoiceservice.getInvoiceList().subscribe((data) => {
      if (data.result != undefined) {
        this.Invoices = data.result;
        console.log(data.result);
        for (var i = 0; i < data.result.length; i++) {
          if (data.result[i].customerName != undefined) {
            let isCustomer = this.customerdata.find(
              (item) => JSON.stringify(item.customerId) == JSON.stringify(data.result[i].customerId)
            );
            if (isCustomer) {
              continue;
            } else {
              this.customerdata.push(data.result[i]);
              this.customerNameIdMap[data.result[i].customerName] =
                data.result[i].customerId._id;
              console.log("customer Id map", this.customerNameIdMap);
            }
          }
        }
        this.onCheckMOSearch();
      }
    });
    this.filteredCustomers = this.searchForm.get("customer")!.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
  }

  getCustomerdata() {
    this.customerdata = [];
    this._customersservice.getCustomersData().subscribe((data) => {
      for (var i = 0; i < data.result.length; i++) {
        if (data.result[i].name != undefined) {
          this.customerdata.push(data.result[i]);
          console.log(this.customerdata);
          this.customerNameIdMap[data.result[i].name] = data.result[i]._id;
          console.log(this.customerNameIdMap);
        }
      }
    });
    this.filteredCustomers = this.searchForm.get("customer")!.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
  }
  private _filter(value: string): string[] {
    if (value != "") {
      const filterValue = value.replace(/[\W_]/g, "").toLowerCase();
      return this.customerdata.filter((option) =>
        option.customerName.replace(/[\W_]/g, "").toLowerCase().includes(filterValue)
      );
    } else {
      return this.customerdata;
    }
  }
  isCustomerSelected = false;
  onCustomerSelected(customerName) {
    if (customerName != "") {
      this.searchForm
        .get("customerId")
        .setValue(this.customerNameIdMap[customerName]);
      this.getData(this.searchForm.value);
      this.isCustomerSelected = true;
    }
  }
  onPaymentChange(event, invoiceRow) {
    let paymentAmount = this.convertNumber(invoiceRow.data["paymentAmount"]);
    let inputAmount = Number(event.target.value);
    if (inputAmount > paymentAmount) {
      let payAmount = inputAmount - paymentAmount;
      this.remainingReceivedAmount = this.remainingReceivedAmount - payAmount;
    } else {
      let payAmount = paymentAmount - inputAmount;
      this.remainingReceivedAmount = this.remainingReceivedAmount + payAmount;
    }
    if (Number(event.target.value) > invoiceRow.data["remainingAmount"]) {
      this.isPaymentValid = false;
      this._toaster.error(
        "Payment amount can not be larger than invoiced amount",
        "Failed",
        { timeOut: 4000 }
      );
    }
    this.paymentCal(invoiceRow, event.target.value);
  }
  paymentCal(invoiceRow, payAmount) {
    invoiceRow.data["paymentAmount"] = this.formatThousandSeperator(payAmount);
    let sum: number = 0;
    this.loadDetailsGrid.forEach(
      (a) => (sum += this.convertNumber(a.paymentAmount))
    );
    console.log(sum);
    this.totalPayment = sum;
  }
  convertNumber(inputValue) {
    inputValue = inputValue.toString();
    return Number(inputValue.replaceAll(",", ""));
  }
  formatThousandSeperator(inputNumber) {
    return this.decimalPipe.transform(inputNumber, "1.2-2");
  }
  onReceiptPaymentChange(event: any) {
    if (parseFloat(event.target.value) > 9999999.999) {
      this.isReceivedValid = false;
      this._toaster.error(
        "Received Amount can be maximum of 7 digits",
        "Error",
        { timeOut: 3000 }
      );
    } else {
      this.isReceivedValid = true;
      /* let bankCharge = this.convertNumber(
        this.searchForm.controls.bankCharge.value
      );
      let discount = this.convertNumber(
        this.searchForm.controls.discount.value
      );
      let roundup = this.convertNumber(this.searchForm.controls.roundup.value);
      this.totalAmount =
        this.convertNumber(this.searchForm.controls.receivedAmount.value) -
        bankCharge +
        discount +
        roundup;
      this.remainingReceivedAmount =
        this.convertNumber(event.target.value) -
        bankCharge +
        discount +
        roundup; */
      let receivedAmount = this.convertNumber(
        this.searchForm.controls.receivedAmount.value
      );
      this.onCalRemAmount(receivedAmount);
    }
  }
  onBankChargeChange(event: any) {
    if (parseFloat(event.target.value) > 9999999.999) {
      this.isBankChargeValid = false;
      this._toaster.error("Bank Charges can be maximum of 7 digits", "Error", {
        timeOut: 3000,
      });
    } else {
      this.isBankChargeValid = true;
      let bankCharge = this.convertNumber(
        this.searchForm.controls.bankCharge.value
      );
      this.onCalRemAmount(bankCharge);
    }
  }
  onCalRemAmount(amount, type = "") {
    let bankCharge = this.convertNumber(
      this.searchForm.controls.bankCharge.value || ""
    );
    let discount = this.convertNumber(
      this.searchForm.controls.discount.value || ""
    );
    let roundup = this.convertNumber(
      this.searchForm.controls.roundup.value || ""
    );
    let receivedAmount = this.convertNumber(
      this.searchForm.controls.receivedAmount.value
    );
    this.totalAmount = receivedAmount + bankCharge + discount + roundup;
    let totalLineAmount = this.loadDetailsGrid.reduce(
      (acc, line) => acc + this.convertNumber(line.paymentAmount),
      0
    );
    if (totalLineAmount === 0) {
      this.remainingReceivedAmount = this.totalAmount;
    } else {
      let amount1 = 0;
      if (this.totalAmount > totalLineAmount) {
      }
      amount1 = this.totalAmount - totalLineAmount;
      if (type == "discount") {
        this.remainingReceivedAmount = this.remainingReceivedAmount + amount1;
      } else {
        this.remainingReceivedAmount = this.remainingReceivedAmount + amount1;
      }
    }
    /* if(this.totalAmount == this.remainingReceivedAmount){
      this.remainingReceivedAmount = this.totalAmount;
    }
    else{
      this.remainingReceivedAmount =
      receivedAmount - bankCharge + discount + roundup;
    } */
  }
  onDiscountChange(event: any) {
    if (parseFloat(event.target.value) > 9999999.999) {
      this.isDiscountValid = false;
      this._toaster.error("Discount can be maximum of 7 digits", "Error", {
        timeOut: 3000,
      });
    } else {
      this.isDiscountValid = true;
      let discount = this.convertNumber(
        this.searchForm.controls.discount.value
      );
      this.onCalRemAmount(discount, "discount");
    }
  }
  onRoundupChange(event: any) {
    if (parseFloat(event.target.value) > 9999999.999) {
      this.isRoundupValid = false;
      this._toaster.error("Round up can be maximum of 7 digits", "Error", {
        timeOut: 3000,
      });
    } else {
      this.isRoundupValid = true;
      let roundup = this.convertNumber(this.searchForm.controls.roundup.value);
      this.onCalRemAmount(roundup);
    }
  }
  onCheckMOSearch() {
    this.getData(this.searchForm.value);
  }
  onBacktoList() {
    this.router.navigateByUrl("/sales/invoice");
  }
  loadDetailsGrid: any[] = [];
  selectedRows = [];
  @ViewChild(DxDataGridComponent, { static: true })
  dataGrid: DxDataGridComponent;

  selectionChanged(e, d) {
    console.log("Received RemainingAmount is: ", this.remainingReceivedAmount);
    if (this.SearchedData[d.loadIndex]["isEdited"] == true) {
      this.dataGrid.instance.deselectRows([d.key]);
      this.SearchedData[d.loadIndex]["isEdited"] = false;
      this.getSelectedCustomerBill();
      console.log(this.loadDetailsGrid[d.loadIndex]);
      /* if (this.remainingReceivedAmount > 0) {
        this.remainingReceivedAmount +=
          this.loadDetailsGrid[d.loadIndex]["remainingAmount"];
        if (
          this.remainingReceivedAmount >
          this.convertNumber(this.searchForm.controls.receivedAmount.value)
        ) {
          this.remainingReceivedAmount = this.convertNumber(
            this.searchForm.controls.receivedAmount.value
          );
        }
      } */
      if (this.totalAmount > this.remainingReceivedAmount) {
        let calPayAmount = this.convertNumber(
          this.loadDetailsGrid[d.loadIndex]["paymentAmount"]
        );
        if (this.remainingReceivedAmount > calPayAmount) {
          this.remainingReceivedAmount =
            this.remainingReceivedAmount + calPayAmount;
          if (this.remainingReceivedAmount > this.totalAmount) {
            this.remainingReceivedAmount = this.totalAmount;
          }
        } else if (this.remainingReceivedAmount == calPayAmount) {
          this.remainingReceivedAmount =
            this.remainingReceivedAmount + calPayAmount;
          if (this.remainingReceivedAmount > this.totalAmount) {
            this.remainingReceivedAmount = this.totalAmount;
          }
        } else {
          this.remainingReceivedAmount =
            this.remainingReceivedAmount + calPayAmount;
          if (this.remainingReceivedAmount > this.totalAmount) {
            this.remainingReceivedAmount = this.totalAmount;
          }
        }
      }

      this.paymentCal(d, 0);
    } else {
      this.dataGrid.instance.selectRows([d.key], true);
      this.SearchedData[d.loadIndex]["isEdited"] = true;
      this.getSelectedCustomerBill();
      let calPayAmount = this.loadDetailsGrid[d.loadIndex]["remainingAmount"];
      if (this.remainingReceivedAmount > 0) {
        if (this.remainingReceivedAmount > calPayAmount) {
          this.remainingReceivedAmount =
            this.remainingReceivedAmount - calPayAmount;
        } else if (this.remainingReceivedAmount == calPayAmount) {
          this.remainingReceivedAmount = 0;
        } else {
          calPayAmount = this.remainingReceivedAmount;
          this.remainingReceivedAmount -= calPayAmount;
        }
      } else {
        calPayAmount = this.remainingReceivedAmount;
      }

      this.paymentCal(d, calPayAmount);
    }
    console.log("Received RemainingAmount is: ", this.remainingReceivedAmount);
  }
  getSelectedCustomerBill() {
    this.selectedCustomer = this.SearchedData.filter((d) => d.isEdited == true);
    this.SearchedData.filter((d) => d.isEdited == false);
  }
  getLoadGrid(loads) {
    const loadsData = loads.filter((x) => x.loadStatus == "6");
    const data = [];
    loadsData.forEach((load) => {
      let filterData = this.Invoices.filter(
        (x) => x.invoiceItemDetails[0].loadNumber == load.loadNumber
      );
      // filterData = filterData.sort((a, b) => b.createdAt - a.createdAt)
      filterData = filterData.reverse();
      let lastIndex = 0;
      let lastInvoiceCancel = filterData.filter(
        (invoice) => invoice.invoiceAmount < 0
      );
      lastIndex = filterData.indexOf(
        lastInvoiceCancel[lastInvoiceCancel.length - 1]
      );
      for (let i = lastIndex + 1; i < filterData.length; i++) {
        const invoiceData = filterData[i];
        let remAmount: number = 0;
        remAmount = Number(invoiceData["invoiceAmount"]) - Number(invoiceData["invoiceItemDetails"][0]["paidAmount"]);
        if (Math.round(Number(remAmount)) > 0 && !isNaN(Number(remAmount))) {
          data.push(invoiceData);
        } else {
          return;
        }
      }
      /* let remAmount: number = 0;
      if (filterData.length > 0) {
        remAmount =
          Number(filterData[filterData.length - 1]["lineItemAmount"]) -
          Number(filterData[filterData.length - 1]["paidAmount"]);
      }
      if (Math.round(Number(remAmount)) > 0 && !isNaN(Number(remAmount))) {
        data.push(filterData[filterData.length - 1]);
      } else {
        return;
      } */
    });
    this.loadDetailsGrid = data;
    if (this.loadDetailsGrid.length > 0) {
      for (var i = 0; i < this.loadDetailsGrid.length; i++) {
        this.loadDetailsGrid[i]["isEdited"] = false;
        this.loadDetailsGrid[i]["paymentAmount"] = 0;
        this.loadDetailsGrid[i]["loadNumber"] = this.loadDetailsGrid[i]["invoiceItemDetails"][0]["loadNumber"];
        this.loadDetailsGrid[i]["remainingAmount"] =
          this.loadDetailsGrid[i]["invoiceAmount"] -
          this.loadDetailsGrid[i]["invoiceItemDetails"][0]["paidAmount"];
        const dwollaCust = this.dwollaCustomerData.find(
          (dc) => dc.customerId === this.loadDetailsGrid[i]["customerId"]
        );
        this.senderDwollaCUstomerData = dwollaCust;
        dwollaCust != undefined
          ? (this.loadDetailsGrid[i]["isDwollaCustomer"] = true)
          : (this.loadDetailsGrid[i]["isDwollaCustomer"] = false);
        dwollaCust != undefined
          ? (this.loadDetailsGrid[i]["dwollaCustomerId"] =
            dwollaCust.dwollaCustomerId)
          : (this.loadDetailsGrid[i]["dwollaCustomerId"] = "");
        this.searchForm.patchValue({
          senderDwollaCustomerId:
            dwollaCust != undefined ? dwollaCust.dwollaCustomerId : "",
        });
        this.searchForm.patchValue({
          isDwollaCustomer: dwollaCust != undefined ? true : false,
        });
      }
    }
    if (this.postedInvoiceList.length > 0) {
      // Filter out invoices already in loadDetailsGrid
      const filteredPostedInvoices = this.postedInvoiceList.filter(postedInvoice => {
        return !this.loadDetailsGrid.some(loadDetail => loadDetail.invoiceId === postedInvoice.No);
      });

      // Add the remaining invoices to loadDetailsGrid
      filteredPostedInvoices.forEach(postedInvoice => {
        let customerInfo = this.customerdata.find((customerInvoice) => customerInvoice?.customerId?.ErpEntityNo == postedInvoice?.Sell_to_Customer_No );
        const invoice = {
          invoiceId: postedInvoice?.No,
          customerName: postedInvoice?.Sell_to_Customer_Name,
          customerId: customerInfo?.customerId,
          loadNumber: postedInvoice?.Load,
          createdAt: postedInvoice?.Posting_Date,
          updatedAt: postedInvoice?.Due_Date,
          invoiceAmount: postedInvoice?.Amount,
          remainingAmount: postedInvoice?.Remaining_Amount,
          paymentAmount: 0,
          isEdited: false,
          isBCDirectPosted: true,
        };
        this.loadDetailsGrid.push(invoice);
      });
    }
    this.SearchedData = this.loadDetailsGrid;
  }
  filterData(event) {
    this.SearchedData = this.loadDetailsGrid.filter(function (e) {
      return e.loadNumbers
        .toString()
        .toLowerCase()
        .includes(event.toString().toLowerCase());
    });
  }
  onSelectedPaymentMethod(event) {
    if (event.target.value == 'CASH' || event.target.value == 'Cash') {
      this.searchForm.controls['bankAccount'].setValidators([Validators.required]);
      this.searchForm.controls['bankAccount'].disable();
      this.isCash = true;
    }
    else {
      this.searchForm.controls['bankAccount'].setValidators([Validators.required]);
      this.searchForm.controls['bankAccount'].enable();
      this.isCash = false;
    }
  }

  onSubmit(isValid) {
    console.log("search form", this.searchForm);
    let bankCharge = this.convertNumber(
      this.searchForm.controls.bankCharge.value || ""
    );
    let discount = this.convertNumber(
      this.searchForm.controls.discount.value || ""
    );
    let roundup = this.convertNumber(
      this.searchForm.controls.roundup.value || ""
    );
    let receivedAmount = this.convertNumber(
      this.searchForm.controls.receivedAmount.value || ""
    );
    let totalReceivedAmount = receivedAmount + bankCharge + discount + roundup;
    console.log(
      "total received amount",
      Number(totalReceivedAmount.toFixed(2)),
      "total payment",
      this.totalPayment
    );
    if (isValid) {
      if (!this.isReceivedValid) {
        this._toaster.error(
          "Received Amount can be maximum of 7 digits",
          "Failed",
          { timeOut: 4000 }
        );
        return;
      } else if (!this.isPaymentValid) {
        this._toaster.error(
          "Payment amount can not be larger than invoiced amount",
          "Failed",
          { timeOut: 4000 }
        );
        return;
      } else if (Number(totalReceivedAmount.toFixed(2)) != this.totalPayment) {
        this._toaster.error(
          "Receive amount and payment amount did not match",
          "Failed",
          { timeOut: 4000 }
        );
      } else {
        if (this.isACH) {
          if (this.searchForm.value.isDwollaCustomer) {
            this.receiverDwollaCUstomerData = this.dwollaCustomerData.find(
              (c) => c.customerId == localStorage.getItem("userId")
            );
            if (this.receiverDwollaCUstomerData != undefined) {
              let dialogConfig = Object.assign(
                { width: "400px" },
                {
                  data: {
                    senderDwollaCustomerId:
                      this.searchForm.value.senderDwollaCustomerId,
                    receiverDwollaCustomerId:
                      this.receiverDwollaCUstomerData.dwollaCustomerId,
                    amount: this.searchForm.value.receivedAmount,
                  },
                },
                { disableClose: true }
              );
              let editDialogRef = this.dialog.open(
                DwollapaymentpopupComponent,
                dialogConfig
              );
              editDialogRef.afterClosed().subscribe((data) => {
                if (data == null) {
                  // this.getData();
                } else {
                  //  this.getData();
                  console.log(data);
                  this.senderFundingSourceId = data.senderFundingSourceId;
                  this.senderFundingSourceName = data.senderFundingSourceName;
                  this.receiverFundingSourceId = data.receiverFundingSourceId;
                  this.recieverFundingSourceName =
                    data.recieverFundingSourceName;
                  this.makePayment();
                }
              });
            } else {
              this._toaster.error(
                "The Receiver Is Not Payment Registered, Payment Registration Required For ACH Payments",
                "Failed",
                { timeOut: 4000 }
              );
              return;
            }
          } else {
            this._toaster.error(
              "The Sender Is Not Payment Registered, Payment Registration Required For ACH Payments",
              "Failed",
              { timeOut: 4000 }
            );
            return;
          }
        } else {
          this.makePayment();
        }
      }
    } else {
      this._toaster.error(
        "Please Input All the required Fields",
        "Validation Error",
        { timeOut: 4000 }
      );
      return;
    }
  }

  /* private makePayment() {
    this.receiptPayment.No = 0;
    this.receiptPayment.Amount = Number(
      this.searchForm.controls.receivedAmount.value.replace(/,/g, "")
    );
    this.receiptPayment.BankAccountNo = this.searchForm.value.bankAccount;
    if(this.searchForm.value.paymentMethod == "ACH"){
      this.receiptPayment.RecieverName = this.receiverDwollaCUstomerData.firstName + " " + this.receiverDwollaCUstomerData.lastName ;
      this.receiptPayment.SenderFundingSource = this.senderFundingSourceId;
      this.receiptPayment.SenderFundingSourceName = this.senderFundingSourceName;
      this.receiptPayment.RecieverFundingSource = this.receiverFundingSourceId;
      this.receiptPayment.RecieverFundingSourceName =this.recieverFundingSourceName;
    }
    this.receiptPayment.PaymentLogDetail = [];
    let count = 0;
    this.SearchedData.forEach(
      function (value) {
        if (this.convertNumber(value.paymentAmount) > 0) {
          count++;
          this.receiptPaymentDetail.No = 0;
          this.receiptPaymentDetail.PaymentLogNo = 0;
          this.receiptPaymentDetail.CustomerNo =
            this.searchForm.value.customerId;
          this.receiptPaymentDetail.InvoiceNo = value.invoiceId;
          this.receiptPaymentDetail.PaymentMethodCode =
            this.searchForm.value.paymentMethod;
          this.receiptPaymentDetail.Payment = this.convertNumber(
            value.paymentAmount
          );
          this.receiptPayment.PaymentLogDetail.push(this.receiptPaymentDetail);
        }
      }.bind(this)
    );

    this.receiptPayment.TotalInvoicePayment = count;
    this.isDataLoading = true;
    let paymentLine = this.selectedCustomer.map((c) => {
      let pd = {
        customerId: c.customerId._id,
        invoiceId: c.invoiceId,
        amount: this.convertNumber(c.paymentAmount).toFixed(2),
        loadPrice: Number(c.invoiceAmount).toFixed(2),
        loadNumber: c.loadNumber,
        lineItemId: c.invoiceItemDetails[0].lineItemId,
        remainingAmount: Number(c.remainingAmount).toFixed(2),
      };
      return pd;
    });
    const receiptData = {
      customerId: this.searchForm.value.customerId,
      customerName: this.searchForm.value.customer,
      paymentDate: this.searchForm.value.date,
      paymentMethod: this.searchForm.value.paymentMethod,
      bankAccount: this.searchForm.value.bankAccount,
      paymentReference: this.searchForm.value.paymentReference,
      receivedAmount: this.convertNumber(
        this.searchForm.controls.receivedAmount.value
      ),
      lineItem: paymentLine,
    };
    let dwollaPayment = {};
    if (this.searchForm.value.paymentMethod === "ACH") {
      dwollaPayment = {
        senderCustomer: this.senderDwollaCUstomerData._id,
        senderFundingSourceId: this.senderFundingSourceId,
        receiverCustomer: this.receiverDwollaCUstomerData._id,
        receiverFundingSourceId: this.receiverFundingSourceId,
        amount: this.convertNumber(
          this.searchForm.controls.receivedAmount.value
        ).toFixed(2),
        paymentMethod: this.searchForm.value.paymentMethod,
        bankAccount: this.searchForm.value.bankAccount,
        paymentDate: this.searchForm.value.date,
        paymentReference: this.searchForm.value.paymentReference,
        lineItem: paymentLine,
      };
    }
    const reqData = {
      lm: receiptData,
      bc: this.receiptPayment,
      dw: dwollaPayment,
    };

    this.loadingVisible = true;
    this._receiptpaymentservice
      .SendForm([reqData.lm, reqData.bc, reqData.dw])
      .subscribe(
        (data) => {
          console.log(data);
          this.loadingVisible = false;
          if (data.Status == "error") {
            this._toaster.error("error", "Error", { timeOut: 4000 });
          } else {
            this.loadingVisible = false;
            this._toaster.success("successfully created", "Success", {
              timeOut: 4000,
            });
            this.router.navigateByUrl("/sales/receipt-history");
          }
        },
        (error) => {
          this.loadingVisible = false;
          let resError = JSON.parse(error._body);
          this._toaster.error(resError.error.error.message, "Error", {
            timeOut: 5000,
          });
        }
      );
  } */
  private makePayment() {
    let paymentLine = this.selectedCustomer.map((c) => {
      console.log(c);
      let pd = {
        customerId: c.customerId._id,
        invoiceId: c.invoiceId,
        amount: this.convertNumber(c.paymentAmount).toFixed(2),
        loadPrice: Number(c.invoiceAmount).toFixed(2),
        loadNumber: c.loadNumber,
        lineItemId: c.invoiceItemDetails ? c.invoiceItemDetails[0].lineItemId : undefined,
        remainingAmount: Number(c.remainingAmount).toFixed(2),
      };
      return pd;
    });
    const receiptData = {
      customerId: this.searchForm.value.customerId,
      customerName: this.searchForm.value.customer,
      paymentDate: this.searchForm.value.date,
      paymentMethod: this.searchForm.value.paymentMethod,
      bankAccount: this.searchForm.value.bankAccount,
      paymentReference: this.searchForm.value.paymentReference,
      receivedAmount: this.convertNumber(
        this.searchForm.controls.receivedAmount.value
      ),
      bankCharge: this.convertNumber(this.searchForm.controls.bankCharge.value || ""),
      discount: this.convertNumber(this.searchForm.controls.discount.value || ""),
      rounding: this.convertNumber(this.searchForm.controls.roundup.value || ""),
      lineItem: paymentLine,
      senderFundingSourceId: "",
      senderFundingSourceName: "",
      senderDwollaId: "",
      isACH: this.isACH,
    };
    if (this.isACH) {
      receiptData.senderFundingSourceId = this.senderFundingSourceId;
      receiptData.senderFundingSourceName =
        this.senderDwollaCUstomerData.fundingSourceName;
      receiptData.senderDwollaId = this.senderDwollaCUstomerData._id;
    }
    this.loadingVisible = true;
    this._receiptpaymentservice.SendForm(receiptData).subscribe(
      (data) => {
        console.log(data);
        this.loadingVisible = false;
        if (data.Status == "error") {
          this._toaster.error("error", "Error", { timeOut: 4000 });
        } else {
          this.loadingVisible = false;
          this._toaster.success("successfully created", "Success", {
            timeOut: 4000,
          });
          this.router.navigateByUrl("/sales/receipt-history");
        }
      },
      (error) => {
        this.loadingVisible = false;
        let resError = JSON.parse(error._body);
        this._toaster.error(resError.error.error.message, "Error", {
          timeOut: 5000,
        });
      }
    );
  }

}
